import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
import { HTTPMethod } from '@/constants/rest';
import { operations } from '@/api/skippay/generated/selfCare';

type MutationBodyCreate =
	operations['customerRequestConfirmCreate']['requestBody']['content']['application/json'];
type MutationResponseCreate =
	| operations['customerRequestConfirmCreate']['responses']['204']['content']
	| undefined;

export function useCustomerRequestConfirmCreateQuery({
	token,
}: MutationBodyCreate): UseQueryResult<MutationResponseCreate> {
	return useQuery({
		queryKey: QUERY_KEYS.customerRequestConfirmCreate(),
		queryFn: async () => {
			const res = await apiSelfCareFetcher<Promise<MutationResponseCreate>>(
				URLS.customerDataRequestConfirmCreate,
				{ method: HTTPMethod.POST, body: { token } }
			);
			return res.json;
		},
	});
}
